import { ColumnDef } from '@tanstack/react-table';
import { Button, Checkbox } from '@ais-ui/ui-core';
import { ArrowUpDown } from 'lucide-react';
import React from 'react';
import { myCustomFilter } from './filterTypes';

export function createColumns(
  accessorKeys: string[],
  formatDateTimeWithTimeZone: (date: Date | undefined | null) => string
): ColumnDef<any>[] {
  // Create other columns based on accessorKeys
  return accessorKeys.map((accessorKey) => {
    switch (accessorKey.toLowerCase()) {
      case 'flag':
      case 'to flag':
      case 'from flag':
        return {
          accessorKey,
          header: ({ column }: { column: any }) => (
            <Button
              variant="ghost"
              className="px-0 w-full flex justify-between rounded-sm space-x-6"
              onClick={() =>
                column.toggleSorting(column.getIsSorted() === 'asc')
              }
            >
              <p>{accessorKey}</p>
              <ArrowUpDown className="ml-2 h-4 w-4" />
            </Button>
          ),
          cell: ({ getValue }: { getValue: any }) => (
            <img
              src={getValue() as string}
              alt="Flag"
              style={{ width: 'auto', height: 'auto' }}
            />
          ),
        };
      case 'distance':
        return {
          accessorKey,
          header: ({ column }: { column: any }) => (
            <Button
              variant="ghost"
              className="px-0 w-full flex justify-between rounded-sm space-x-6"
              onClick={() =>
                column.toggleSorting(column.getIsSorted() === 'asc')
              }
            >
              <p>{accessorKey}</p>
              <ArrowUpDown className="ml-2 h-4 w-4" />
            </Button>
          ),
          accessorFn: (row: any) => {
            const value = row[accessorKey];
            const numValue = Number(value);
            return !isNaN(numValue) ? numValue.toFixed(2) : value;
          },
          filterFn: myCustomFilter,
        };
      case 'begin':
      case 'end':
      case 'enter':
      case 'exit':
      case 'timestamp':
      case 'ata':
      case 'atd':
      case 'date':
      case 'arrival':
      case 'departure':
      case 'dats':
      case 'act':
      case 'dea':
      case 'edats':
      case 'sdats':
      case 'end date':
      case 'start date':
      case 'cpat':
      case 'actts':
      case 'deats':
      case 'eta':
        return {
          accessorKey,
          header: ({ column }: { column: any }) => (
            <Button
              variant="ghost"
              className="px-0 w-full flex justify-between rounded-sm space-x-6"
              onClick={() =>
                column.toggleSorting(column.getIsSorted() === 'asc')
              }
            >
              <p>{accessorKey}</p>
              <ArrowUpDown className="ml-2 h-4 w-4" />
            </Button>
          ),
          cell: ({ getValue }: { getValue: any }) =>
            formatDateTimeWithTimeZone(getValue() as Date),
        };
      default:
        return {
          accessorKey,
          header: ({ column }: { column: any }) => (
            <Button
              variant="ghost"
              className="px-0 w-full flex justify-between rounded-sm space-x-6"
              onClick={() =>
                column.toggleSorting(column.getIsSorted() === 'asc')
              }
            >
              <p>{accessorKey}</p>
              <ArrowUpDown className="ml-2 h-4 w-4" />
            </Button>
          ),
          accessorFn: (row: any) => row[accessorKey],
          filterFn: myCustomFilter,
        };
    }
  });
}
